import { Injectable } from "@angular/core";
import { UTCDate } from "@ankaadia/ankaadia-shared";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import {
  ExcelAddInDto,
  GetAvailableOrganizationsGQL,
  GetSalesDataGQL,
  OrganizationListDto,
  SalesTableType,
} from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SalesDataService {
  constructor(
    private readonly getAvailableOrganizationsQuery: GetAvailableOrganizationsGQL,
    private readonly getSalesDataQuery: GetSalesDataGQL
  ) {}

  getOrganizationData(): Observable<OrganizationListDto> {
    return this.getAvailableOrganizationsQuery.subscribe().pipe(
      map((result) => result.data.getAvailableOrganizations),
      reportProgress("getAvailableOrganizations", "1", false, { silent: true })
    );
  }

  getSalesData(
    language: string,
    fromDate: UTCDate,
    toDate: UTCDate,
    tableTypes: SalesTableType[],
    organizationIds: string[],
    includeAllOrganizations: boolean
  ): Observable<ExcelAddInDto> {
    return this.getSalesDataQuery
      .subscribe({
        input: {
          language: language,
          fromDate: fromDate,
          toDate: toDate,
          tables: tableTypes,
          organizationIds: includeAllOrganizations ? null : organizationIds,
          includeAllOrganizations: includeAllOrganizations,
        },
      })
      .pipe(
        map((result) => result.data.getSalesData),
        reportProgress("getSalesData", "1", false, { silent: true })
      );
  }
}
